/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_user = {
    readonly canShowSellerName: boolean | null;
    readonly " $refType": "PdpSharedDealerDetailsHeader_user";
};
export type PdpSharedDealerDetailsHeader_user$data = PdpSharedDealerDetailsHeader_user;
export type PdpSharedDealerDetailsHeader_user$key = {
    readonly " $data"?: PdpSharedDealerDetailsHeader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsHeader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsHeader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '166cbc5213651741bece2eda9e089072';
export default node;
